(() => {
  const nativeFetch = window.fetch.bind(window);
  const variants = new Set(['50328894570790', '50328894603558']);
  const limit = 5;
  const message = 'Maximum 5 Fluorinar-C™ spools per order, across both diameters. Contact sales@nilepolymers.com for larger quantities.';
  let queue = Promise.resolve();
  const isC = item => variants.has(String(item.variant_id || item.id));
  window.fetch = function(input, options = {}) {
    const url = typeof input === 'string' || input instanceof URL ? new URL(input, location.origin) : null;
    if (!url || url.origin !== location.origin || !/\/cart\/(add|change|update)(\.js)?$/.test(url.pathname) || !options.body) return nativeFetch(input, options);
    const task = queue.then(async () => {
      let data;
      try {
        if (options.body instanceof FormData || options.body instanceof URLSearchParams) data = Object.fromEntries(options.body.entries());
        else data = JSON.parse(options.body);
      } catch { return nativeFetch(input, options); }
      const cartResponse = await nativeFetch((window.Shopify?.routes?.root || '/') + 'cart.js', {cache:'no-store'});
      if (!cartResponse.ok) throw new Error('Unable to verify cart quantity. Please try again.');
      const cart = await cartResponse.json();
      let total = cart.items.filter(isC).reduce((sum, item) => sum + Number(item.quantity), 0);
      const currentTotal = total;
      if (/\/add(\.js)?$/.test(url.pathname)) {
        const additions = data.items || [data];
        total += additions.filter(isC).reduce((sum, item) => sum + Number(item.quantity || 1), 0);
      } else if (/\/change(\.js)?$/.test(url.pathname)) {
        const item = data.line ? cart.items[Number(data.line) - 1] : cart.items.find(item => String(item.key) === String(data.id) || String(item.variant_id) === String(data.id));
        if (item && isC(item)) total += Number(data.quantity) - Number(item.quantity);
      } else {
        let updates = data.updates;
        if (!updates) updates = Object.fromEntries(Object.entries(data).filter(([key]) => /^updates\[/.test(key)).map(([key,value]) => [key.slice(8,-1), value]));
        cart.items.forEach((item,index) => {
          if (!isC(item)) return;
          const value = Array.isArray(updates) ? updates[index] : updates?.[item.key] ?? updates?.[item.variant_id];
          if (value !== undefined) total += Number(value) - Number(item.quantity);
        });
      }
      if (total > limit && total > currentTotal) return new Response(JSON.stringify({status:422,message,description:message}), {status:422,headers:{'Content-Type':'application/json'}});
      return nativeFetch(input,options);
    });
    queue = task.catch(() => {});
    return task;
  };
})();